const getUrlHost = () => {
    return window.location.host
}
const getUrlHostname = () => {
    return window.location.hostname;
}
export const pathHelper = {
    getUrlHost,
    getUrlHostname
}
